/**
 * useMultimoneda — indica si el condominio activo tiene multimoneda habilitada.
 *
 * Lee el flag `multimoneda_activa` guardado en localStorage durante el login.
 * Si el usuario no tiene condominio asignado (superadmin) devuelve false.
 *
 * Uso:
 *   const multimoneda = useMultimoneda();
 *   // true  → mostrar campos USD, TC, equivalencias
 *   // false → modo CRC clásico (ocultar todo lo multimoneda)
 */
export function useMultimoneda() {
  return localStorage.getItem("multimoneda_activa") === "true";
}
